import React from 'react';
import LikeComponent from '../components/like';
import LikeActions from '../actions/like';

const LikeContainer = props => {
  return (
    <LikeComponent
      { ...props }
      createLikeForLikeable={ LikeActions.createForLikeable }
      destroyLikeForLikeable={ LikeActions.destroyForLikeable }
      fetchUsers={ LikeActions.fetchUsers } />
  );
}

export default LikeContainer;
